if (!customElements.get('grouped-products')) {
  class GroupedProducts extends HTMLElement {
    constructor() {
      super();

      // Selectors
      this.thumbs = this.querySelectorAll('[data-thumb]');
      this.label = this.querySelector('[data-color-name]');

      // Event listeners
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('mouseenter', (event) => {
          if (document.querySelector('html').classList.contains('touch')) {
            return;
          }
          // Get the target
          const target = event.currentTarget || event.target;
          if (!target) {
            return false;
          }
          this.updateLabel(target);
        });

        thumb.addEventListener('mouseleave', (event) => {
          if (document.querySelector('html').classList.contains('touch')) {
            return;
          }
          // Get the target
          const target = event.currentTarget || event.target;
          if (!target) {
            return false;
          }
          this.resetLabel();
        });
      });
    }

    /**
     * Update label
     * @param {object} target
     */
    updateLabel(target) {
      if (!target || !this.label) return false;

      // Update title
      this.label.innerHTML = target.dataset.thumb || '';
    }

    /**
     * Reset label to default
     */
    resetLabel() {
      if (!this.label) return false;

      // Update title
      this.label.innerHTML = this.label.dataset.colorName || '';
    }
  }

  window.GroupedProducts = GroupedProducts;

  customElements.define('grouped-products', GroupedProducts);
}
